import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { setPlaying } from "../../store/audioEngineSlice";
import { sendPlayCommand, sendPauseCommand } from '../../utils/videoModuleCommands';
import { playerRefs } from "../../store/videoModuleSlice";

const PlayPauseControl: React.FC = () => {
    const dispatch = useDispatch();
    const { isPlaying } = useSelector((state: RootState) => state.audioEngine);
    const readyStates = useSelector((state: RootState) => state.videoModuleReadiness.modules);
    const readyModuleIds = Object.entries(readyStates)
        .filter(([_, state]) => state.isPlayerReady)
        .map(([id]) => id);

    const handlePlayPause = () => {
        const newPlayingState = !isPlaying;
        dispatch(setPlaying(newPlayingState));

        readyModuleIds.forEach(moduleId => {
            const player = playerRefs[moduleId];
            if (player) {
                if (newPlayingState) {
                    sendPlayCommand(player);
                } else {
                    sendPauseCommand(player);
                }
            }
        });
    };

    return (
        <button
            onClick={handlePlayPause}
            style={{
                background: isPlaying ? 'var(--danger)' : 'var(--success)',
                border: 'none',
                color: '#000',
                padding: '6px 16px',
                fontSize: '11px',
                fontWeight: 600,
                cursor: 'pointer',
                minWidth: '72px',
            }}
        >
            {isPlaying ? '■ STOP' : '▶ PLAY'}
        </button>
    );
};

export default PlayPauseControl;
